var lorem = {};
module["exports"] = lorem;
lorem.words = require("./words");
lorem.supplemental = require("./supplemental");